module.exports = __webpack_public_path__ + "static/media/2-mobile.f7be52af.jpg";